import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserGraduate, faBuilding, faVial } from '@fortawesome/free-solid-svg-icons';

function Sobre() {
    return (
        <section id="about">
            <p class="anchor" id="sobre"></p>
            <div className="container">
                <div className="row about-container">
                    <div className="col-lg-6 content order-lg-1 order-2">
                        <h2 className="title">Sobre o NEEQ-FEUP</h2>
                        <p>
                            O Núcleo de Estudantes de Engenharia Química da Faculdade de Engenharia da Universidade do Porto (NEEQ-FEUP) é uma organização associativa composta por quatro departamentos e trinta e nove membros ativos. Tem como objetivos, apoiar os estudantes da L.EQ, do M.EQ e de Doutoramento, oferecendo um vasto conjunto de ferramentas que enriqueçam o seu percurso académico.
                        </p>
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-sm-4">
                                    <div className="icon-box wow fadeInUp">
                                        <div className="icon">
                                            <FontAwesomeIcon icon={faUserGraduate} className="custom-icon" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="icon-box wow fadeInUp" data-wow-delay="0.2s">
                                        <div className="icon">
                                            <FontAwesomeIcon icon={faBuilding} className="custom-icon" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                    <div className="icon-box wow fadeInUp" data-wow-delay="0.4s">
                                        <div className="icon">
                                            <FontAwesomeIcon icon={faVial} className="custom-icon" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 background order-lg-2 order-1 wow fadeInRight">
                        <img src="img/banner.JPG" className="img-fluid" alt="" />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Sobre;
